import Vue from 'vue'

export default {
  setPriorityRules(state, data) {
    state.priorityRules = data
  },
  setPriorityInfrastructure(state, data) {
    state.priorityInfrastructure = data
  },
  setPrioritySource(state, data) {
    state.prioritySource = data
  },
  setPriorityRuleToEdit(state, data) {
    state.priorityRuleToEdit = data
  },
  setPriorityFlows(state, data) {
    state.priorityFlows = data
  },
  setShowPriorityModal(state, data) {
    state.showPriorityModal = data
  },

  updatePriorityMapData(state, data) {
    for (let field in data) {
      state.priorityMapData[field] = data[field]
    }
  },

  setPriorityMapParams(state, data) {
    state.priorityMapParams = data
  },
  setPriorityPeriod(state, data) {
    state.priorityPeriod = data
  },
  setPriorityFlowAction(state, data) {
    state.priorityFlowAction = data
  },
  setForceUpdatePriorityFlows(state, data) {
    state.forceUpdatePriorityFlows = data
  },
  setPriorityLoadingData(state, action) {
    state.priorityLoadingData = action ? state.priorityLoadingData + 1 : state.priorityLoadingData - 1
  }
}



// WEBPACK FOOTER //
// ./src/store/priorities/mutations.js